import type {
  AssetPosition,
  AssetPositionAction,
  CompanyAssetAction,
  ConfigAssetAction,
  RelayAssetAction,
} from "kubb";
import type React from "react";
import { useState } from "react";
import type { RequireExactlyOne } from "type-fest";
import type { Asset } from "utils/object";
import { Button } from "../../../components/Theme/button";
import AssetActionConfirmModal from "./AssetActionConfirmModal";

interface Props {
  asset?: Asset;
  assetPosition?: AssetPosition;
  action:
    | (CompanyAssetAction | RelayAssetAction | ConfigAssetAction)
    | AssetPositionAction;
  actionName: string;
  onComplete?: () => any;
}

type PProps = RequireExactlyOne<Props, "asset" | "assetPosition">;

export default function CreateActionButton(props: PProps): React.ReactElement {
  const [open, setOpen] = useState(false);

  const openModal = (): void => {
    setOpen(true);
  };

  const closeModal = (): void => {
    setOpen(false);
  };

  return (
    <>
      <Button color={"brandLight"} onClick={openModal}>
        {props.actionName}
      </Button>
      {props.asset && (
        <AssetActionConfirmModal
          show={open}
          asset={props.asset}
          action={
            props.action as
              | CompanyAssetAction
              | RelayAssetAction
              | ConfigAssetAction
          }
          close={closeModal}
          description={props.actionName}
          onComplete={props.onComplete}
        />
      )}
      {props.assetPosition && (
        <AssetActionConfirmModal
          show={open}
          assetPosition={props.assetPosition}
          assetPositionAction={props.action as AssetPositionAction}
          close={closeModal}
          description={props.actionName}
          onComplete={props.onComplete}
        />
      )}
    </>
  );
}
